<div class="css-simple-pill" [ngClass]="{ disabled: disabled }" [style.flex-direction]="flexDirection">
  <img *ngIf="imageSrc" src="{{ imageSrc }}" alt="" />
  <div>{{ text }}</div>
</div>
